import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000BasicDialog from '../../../u2000Core/components/dialog/U2000BasicDialog';
import { FaUndoAlt, FaTrashAlt } from 'react-icons/fa';
import { NS } from '../../U3208';
import { u3208SourceDisplayName, type U3208DocSource } from '../../U3208Service';

const cancelButtonClass = `inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-xs transition-all duration-200
  hover:bg-gray-50 hover:border-gray-400 hover:text-gray-900 hover:shadow-md
  focus:outline-hidden focus:ring-2 focus:ring-gray-500 focus:ring-offset-2
  active:bg-gray-100 active:scale-95
  disabled:cursor-not-allowed disabled:opacity-60`;
const dangerButtonClass = `inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg shadow-xs transition-all duration-200
  hover:bg-red-700 hover:shadow-md
  focus:outline-hidden focus:ring-2 focus:ring-red-500 focus:ring-offset-2
  active:bg-red-800 active:scale-95
  disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-200 disabled:opacity-60 disabled:shadow-none`;

export interface U3208DeleteSourceDlgProps {
  isOpen: boolean;
  source: U3208DocSource | null;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const U3208DeleteSourceDlg: React.FC<U3208DeleteSourceDlgProps> = ({
  isOpen,
  source,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  if (!isOpen || !source) return null;

  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('lblDeleteSourceDlgTitle', { ns: NS })}
      width="medium"
    >
      <div className="flex flex-col gap-4 px-6 py-4">
        <p>{t('msgDeleteSource', { ns: NS, name: u3208SourceDisplayName(source) })}</p>
        <div className="flex justify-end gap-2 border-t border-gray-200 pt-4">
          <button type="button" className={cancelButtonClass} onClick={onClose} disabled={submitting}>
            <FaUndoAlt className="h-4 w-4" />
            {t('btnCancel', { ns: NS })}
          </button>
          <button type="button" className={dangerButtonClass} onClick={onConfirm} disabled={submitting}>
            <FaTrashAlt className="h-4 w-4" />
            {t('action.deleteSource', { ns: NS })}
          </button>
        </div>
      </div>
    </U2000BasicDialog>
  );
};

export default U3208DeleteSourceDlg;
